import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { IPatientRepository } from './Ipatient.repository';
import { ApiResponse, Patient, PatientRequest, SearchArchiveOptions, SearchArchiveResult, SearchItems, SearchOptions, SearchResult } from './models';


@Injectable({ providedIn: 'root' })
export class PatientRepository implements IPatientRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }

	getPatient(patientGuid: string): Observable<ApiResponse<Patient>> {
		const params = new HttpParams().set('id', patientGuid);
		return this.httpClient.get<ApiResponse<Patient>>(this.config.domainPatientAPI + '/api/patients/GetPatient', { params });
	}

	deletePatient(patientGuid: string): Observable<ApiResponse<any>> {
		const params = new HttpParams().set('id', patientGuid);
		return this.httpClient.post<ApiResponse<any>>(this.config.domainPatientAPI + '/api/patients/DeletePatient', null, { params });
	}

	savePatient(patientRequest: PatientRequest): Observable<ApiResponse<Patient>> {
		return this.httpClient.post<ApiResponse<Patient>>(this.config.domainPatientAPI + '/api/patients/CreatePatient', patientRequest);
	}

	updatePatient(patient: Patient): Observable<ApiResponse<any>> {
		return this.httpClient.post<ApiResponse<Patient>>(this.config.domainPatientAPI + '/api/patients/UpdatePatient', patient);
	}

	search(options: SearchOptions): Observable<ApiResponse<SearchResult<SearchItems>>> {
		return this.httpClient.post<ApiResponse<SearchResult<SearchItems>>>(this.config.domainPatientAPI + '/api/patients/Search', options);
	}

	advancedSearch(options: SearchOptions): Observable<ApiResponse<SearchResult<SearchItems[]>>> {
		return this.httpClient.post<ApiResponse<SearchResult<SearchItems[]>>>(this.config.domainPatientAPI + '/api/patients/SearchPatientAndCases', options);
	}

	archiveSearch(options: SearchArchiveOptions): Observable<ApiResponse<SearchArchiveResult>> {
		return this.httpClient.post<ApiResponse<SearchArchiveResult>>(this.config.domainPatientAPI + '/api/archive/search', options);
	}

}
